import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { getUserSelector } from '../../../../../user';
import { AccountLoggedIn } from './account-logged-in';
import { AccountStub } from './account-stub';

export const AccountSection: FunctionComponent = () => {
    const user = useSelector(getUserSelector);

    if (user) {
        return <AccountLoggedIn user={user} />;
    }

    return <AccountStub />;
};
